// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import CarryOutTwoToneSvg from "@fishx/icons-svg/es/asn/CarryOutTwoTone";
import FishxIcon from '../components/FishxIcon';

var CarryOutTwoTone = function CarryOutTwoTone(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: CarryOutTwoToneSvg
  }));
};

CarryOutTwoTone.displayName = 'CarryOutTwoTone';
export default React.forwardRef(CarryOutTwoTone);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/CarryOutTwoTone.js
// module id = 2188
// module chunks = 0